<template>
    <div class="inline-flex" :class="spacing">
        <div :class="flex" class="text-center" v-for="i in 5">
            <font-awesome-icon
                :size="size"
                :icon="['fad', 'star-half']"
                class="cursor-pointer outline-none"
                :class="`type-${getStarType(i)}`"
                @click="emitValue($event, i)"
            ></font-awesome-icon>
        </div>
    </div>
</template>
<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
    components: { FontAwesomeIcon },
    emits: ['update:modelValue'],
    props: {
        modelValue: [String, Number],
        size: {
            default: "3x",
            type: String
        },
        spacing: String,
        flex: {
            default: "flex-1",
            type: String
        }
    },
    computed: {
        starRating() {
            const realRating = this.modelValue / 2;

            // Minimum rating of 1 star
            if (realRating < 1) return 1;

            return realRating;
        }
    },
    methods: {
        getStarType(starNumber) {
            if (this.starRating >= starNumber) return 'full';

            if (this.starRating < (starNumber - 0.5)) return 'empty';

            return 'half';
        },
        emitValue($event, index) {
            // Emit the rating that the user has clicked in
            // We'll need to times the index by 2 to achieve this
            this.$emit('update:modelValue', index * 2);

            // const halfStarClick = $event.target.classList.contains('fa-primary');

            // if (halfStarClick) {
            //     this.$emit('update:modelValue', (index * 2) - 1);
            // } else {
            //     // Emit the rating that the user has clicked in
            //     // We'll need to times the index by 2 to achieve this
            //     this.$emit('update:modelValue', index * 2);
            // }


        }
    }
};
</script>


<style lang="scss" scoped>


:deep(.fa-primary),
:deep(.fa-secondary) {
    @apply transition-all;
}

:deep(.type-half) {
    --fa-primary-color: theme('colors.orange');
    --fa-secondary-color: theme('colors.grey.200');
    --fa-secondary-opacity: 1;
}

:deep(.type-full) {
    --fa-primary-color: theme('colors.orange');
    --fa-secondary-color: theme('colors.orange');
    --fa-secondary-opacity: 1;
}

:deep(.type-empty) {
    --fa-primary-color: theme('colors.grey.200');
    --fa-secondary-color: theme('colors.grey.200');
    --fa-secondary-opacity: 1;
}

</style>
